import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "motion/react";
import { Sparkles } from "lucide-react";

export default function LoadingScreen() {
  const [msgIdx, setMsgIdx] = useState(0);
  const msgs = [
    "Finding possible study directions based on your answers...",
    "Checking courses, universities, budget and scholarship options...",
    "Preparing your suggestions...",
  ];
  useEffect(() => {
    const t1 = setTimeout(() => setMsgIdx(1), 1800);
    const t2 = setTimeout(() => setMsgIdx(2), 3600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-violet-600 to-purple-700 flex items-center justify-center shadow-2xl shadow-violet-500/30 mb-8">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        >
          <Sparkles className="w-8 h-8 text-white" />
        </motion.div>
      </div>
      <AnimatePresence mode="wait">
        <motion.p
          key={msgIdx}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="text-[16px] text-slate-700 max-w-sm leading-relaxed"
          style={{ fontWeight: 500 }}
        >
          {msgs[msgIdx]}
        </motion.p>
      </AnimatePresence>
      <div className="flex gap-2 mt-8">
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className="w-2 h-2 rounded-full bg-violet-400"
            animate={{ scale: [1, 1.5, 1], opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.2, repeat: Infinity, delay: i * 0.4 }}
          />
        ))}
      </div>
    </div>
  );
}
